export default [
  {
    path: '/newsletter',
    name: 'Newsletter',
    component: () =>
      import(/* webpackChunkName: 'newsletter' */ './views/Index.vue')
  }
]
